import {Component, OnInit, Input, EventEmitter, Output, SimpleChanges} from "@angular/core";
import {UserService} from "../../services/user.service";
import {Constants} from "../../services/constants";
import {SharedService} from "../../services/shared.service";


@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls:['./sign-up.component.scss']

})
export class SignUpComponent implements OnInit {
  user: any = {};
  role: string;
  hasError = false;
  errorMessage = "";
  isCreated = false;
  isMothershipTenant: boolean = false;
  @Input() fromReseller: boolean =false;
  @Input() email: string;
  @Output() userCreated = new EventEmitter();
  formStep: number = 1;
  inProgress: boolean = false;
  countriesList: Array<string> = Constants.COUNTRIES();

  constructor(private userService: UserService,
              private sharedService: SharedService) {
    this.user.address = {};
    this.isMothershipTenant = Constants.IS_MOTHERSHIP_TENANT();
    if(!this.isMothershipTenant){
      this.role = "ROLE_USER";
      this.formStep=2;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['email']){
      if(changes['email'].currentValue == null){
        this.hasError = null;
        this.errorMessage = null;
        this.user = {};
        this.user.address = {};
      }
      else {
        this.user.email = changes['email'].currentValue;
      }
    }
  }

  ngOnInit() {
    this.user.email = this.sharedService.getParameter("email")
  }

  onSubmit(data) {
    this.inProgress = true;
    this.filterDomain();
    this.userService.signUp(data, this.role, this.fromReseller)
      .finally(()=>{
        this.inProgress = false;
      })
      .subscribe(response=> {
          this.hasError = false;
          this.isCreated = true;
          this.userCreated.emit(true);
        },
        error=> {
          this.hasError = true;
          let errorBody=JSON.parse(error._body);
          this.errorMessage = errorBody.message;
        });
    return false;
  }


  filterDomain() {
    let value=this.user.domain;
    if(!value) {
      return;
    }

    value = value.replace(/\/$/, "");
    value = value.replace("https://", "");
    value = value.replace("http://", "");
    value = value.replace("www.", "");
    this.user.domain = value.toLowerCase();
  }

  invalidNext: boolean = false;

  gotoSignUpForm() {
    if(this.role) {
      this.formStep = 2;
      this.invalidNext = false;
    } else {
      this.invalidNext = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sign-up/sign-up.component.ts